<p>list-detail-package works!</p>